import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../common/rest.operators';
import { PayloadAction } from '../../store.model';
import { EvaluationService } from '../core';
import { getModuleInjector } from '../evaluation.metadata';

import { ActionType } from './main.action';
import { Reload, reloadResult } from './state/reload.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const reload = (action: Observable<PayloadAction<ActionType, Reload>>) =>
    action.pipe(
        ofType(ActionType.EVAL_MAIN__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);
            return service.listTemplateVersions(null).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            templateVersions: ret,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );

export const mainEpics = [reload];
